import { Action, createReducer, on } from '@ngrx/store';
import * as UploadsApiActions from '../actions/uploads-api.actions';
import { GUIUploadListItem, GUIUploadDetail } from '../../models/Uploads';
import { IDjangoErrors } from '../../../../shared/models/DjangoErrors';

export interface UploadsState {
  list: GUIUploadListItem[];
  detail: GUIUploadDetail | null;
  loading: boolean;
  errors: IDjangoErrors | null;
}

const initialState: UploadsState = {
  list: [],
  detail: null,
  loading: false,
  errors: null,
};

export const reducer = createReducer(
  initialState,
  on(UploadsApiActions.ListGUIUploadsSuccess, (state, { payload }) => ({ ...state, list: payload })),
  on(UploadsApiActions.ListGUIUploadsFailure, (state) => ({ ...state })),

  on(UploadsApiActions.GetGUIUploadDetailSuccess, (state, { payload }) => ({ ...state, detail: payload })),
  on(UploadsApiActions.GetGUIUploadDetailFailure, (state) => ({ ...state, detail: null }))
);

export function UploadsReducer(state: UploadsState | undefined, action: Action) {
  return reducer(state, action);
}
